

































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import Radio from '@/components/Radio/index.vue'
import Grid from '@/components/Grid/Grid.vue'
import Xscam from './XSCam.vue'
import Form from '@/form'
import { cloner } from '@/units'
import { hasOwnProp } from '@/utils'

@Component({
  components: {
    Grid, Radio,
    Xscam
  }
})

export default class ViewForm extends Vue {
  @Prop({
    type: Object,
    required: true
  }) field!: any

  // __DATA
  private form: any = new Form(this.field)
  private ranking: boolean = false
  private valve: any = this.setValve(this.field.cameras)

  // __METHODS
  private touch (): void {
    this.form.set({
      cameras: this.valve.map((h: any) => {
        return {
          id  : h.id,
          rank: h.rank
        }
      })
    })

    this.$validator.validate()
      .then(valid => {
        if (valid) {
          this.$emit('callback', this.form.data())
        }
      })
  }

  private add (param: any): void {
    const hasVal: boolean = this.valve.some((v: any) => v.id === param.id)
    if (hasVal) {
      this.valve = this.valve.remove('id', param.id)
    }
    else if (this.valve.length < 12) {
      const vs: any = cloner(param)
        vs.rank = (this.valve.length + 1)
      this.valve.push(vs as any)
    }
    this.rank()
  }

  private apply (): void {
    this.ranking = !this.ranking
    if (this.ranking) this.rank()
  }

  private sort ({ items }: any): void {
    for (const { item, sort } of items) {
      item.rank = (sort + 1)
    }
  }

  private rank (): void {
    const valve: any = this.valve.orderBy('rank', 'asc')
    for (const v of valve) {
      v.rank = (valve.indexOf(v) + 1)
    }
    this.valve = valve as any
  }

  private focus (id: number): boolean {
    return this.valve.some((v: any) => v.id === id)
  }

  private setValve (param: any): any {
    const x: any = cloner(param)
    if (x.length) {
      const cameras: any = this.$store.getters['APP.COG/cameras']
      return x.map((h: any) => {
        let ch: any = cameras.find((c: any) => c.id === h.id)
          ch.rank = h.rank
          return ch
      }).orderBy('rank', 'asc')
    } else {
      return []
    }
  }

  // __COMPUTED
  private get button (): string {
    return hasOwnProp(this.field, 'id') && this.field.id
      ? 'button.save'
      : 'button.submit'
  }

  /**
   * DB Facker.
   */
  private get db (): any {
    let cameras: any = this.$store.getters['APP.COG/cameras']
    cameras = cameras.keep('isActive', 1)
    cameras = cameras.groupBy('city')
    return {
      cameras,
      active: [
        { id: 1, name: this.$t('enabled') },
        { id: 0, name: this.$t('disabled') }
      ]
    }
  }

  // __WATCH
  @Watch('valve') private vv (v: any): void {
    this.form.set({
      cameras: v
    })
  }
}
